// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../assets/images/logo512.png';

const Footer = () => {
  return (
    <footer className="casc-footer">
      <div className="casc-footer-container">
        <div className="casc-footer-divider"></div>
        <div className="casc-footer-top">
          <div className="casc-footer-logo">
            <img src={logo} alt="Clean Air Student Council Logo" className="casc-footer-logo-img" />
            <span className="casc-footer-logo-text">Clean Air Student Council</span>
          </div>

          <div className="casc-footer-columns">
            <div className="casc-footer-column">
              <h3 className="casc-footer-heading">HOME</h3>
              <ul className="casc-footer-links">
                <li><Link to="/" className="casc-footer-link">About</Link></li>
                <li><Link to="/team" className="casc-footer-link">Our Team</Link></li>
                <li><Link to="/contact" className="casc-footer-link">Contact</Link></li>
              </ul>
            </div>

            <div className="casc-footer-column">
              <h3 className="casc-footer-heading">OUR WORK</h3>
              <ul className="casc-footer-links">
                <li><Link to="/conference" className="casc-footer-link">Clean Air Conference</Link></li>
                <li><Link to="/publicspeakingcontest" className="casc-footer-link">Public Speaking Contest</Link></li>
                <li><Link to="/others" className="casc-footer-link">Archive</Link></li>
              </ul>
            </div>

            <div className="casc-footer-column">
              <h3 className="casc-footer-heading">SOCIAL MEDIA</h3>
              <ul className="casc-footer-links">
                <li><a href="https://www.instagram.com/casc.hk/" target="_blank" rel="noopener noreferrer" className="casc-footer-link">Instagram</a></li>
                <li><a href="https://www.youtube.com/@CleanAirNetworkhk/" target="_blank" rel="noopener noreferrer" className="casc-footer-link">YouTube</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="casc-footer-bottom">
          <p className="casc-footer-about">
            Est. 2019, Clean Air Student Council is the city's largest and oldest student-led environmental group.
          </p>
          <div className="casc-footer-divider"></div>
          <div className="casc-footer-legal">
            <p className="casc-footer-copyright">
              Copyright © {new Date().getFullYear()} Clean Air Student Council. All rights reserved. Website built by Yvonne Chan.
            </p>
            <p className="casc-footer-location">Hong Kong</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;